import Storage from './storage'

class OnlineChecker {
  static #lastCheck = 0
  static #lastStatus = true
  static #intervalId = 0

  static async isOnline(cacheDuration = 5000, timeoutDuration = 3000) {
    const now = Date.now()
    if (now - this.#lastCheck < cacheDuration) {
      return this.#lastStatus
    }

    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), timeoutDuration)

    try {
      await fetch('https://clients3.google.com/generate_204', {
        method: 'GET',
        mode: 'no-cors',
        cache: 'no-store',
        signal: controller.signal,
      })

      clearTimeout(timeout)
      this.#lastCheck = now
      this.#lastStatus = true
      return true
    } catch {
      clearTimeout(timeout)
      this.#lastCheck = now
      this.#lastStatus = false
      return false
    }
  }

  static init(interval = 10000) {
    if (this.#intervalId) return
    Storage.save('onlineStatus', { isOnline: true, isOffline: false })

    let lastStatus = this.#lastStatus

    this.#intervalId = setInterval(async () => {
      const status = await this.isOnline(0) // pas de cache dans le loop
      if (status !== lastStatus) {
        lastStatus = status
        Storage.save('onlineStatus', {
          isOnline: lastStatus,
          isOffline: !lastStatus,
        })
        if (status) {
          console.log('✅ Connexion Internet rétablie !')
        } else {
          console.log('🚫 Connexion Internet perdue !')
        }
      }
    }, interval)
  }

  /**
   * Stoppe le vérificateur automatique.
   */
  static stop() {
    if (this.#intervalId) {
      clearInterval(this.#intervalId)
      this.#intervalId = 0
      console.log('🛑 OnlineChecker arrêté.')
    }
  }
}

export default OnlineChecker
